module.exports = __webpack_public_path__ + "img/ko_kr.877da358.png";